import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from './Icons';
import { PILLARS } from '../data/catalog';

const Services = () => {
  const [openId, setOpenId] = useState(PILLARS[0].id);

  return (
    <section className="band band-line" id="services">
      <div className="wrap">
        <motion.div
          className="section-head"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="eyebrow-dark">Service Catalog</span>
          <h2>Eight connected capabilities, one delivery pipeline</h2>
          <p>
            Every engagement draws from the same disciplines &mdash; engineering, security,
            operations and the accounting that keeps them costed &mdash; scoped independently or
            combined into a single modernization program.
          </p>
        </motion.div>

        <div className="pillars">
          {PILLARS.map((p) => {
            const isOpen = openId === p.id;
            return (
              <div key={p.id} id={p.id} className={`pillar ${isOpen ? 'is-open' : ''}`}>
                <button
                  className="pillar-head"
                  aria-expanded={isOpen}
                  onClick={() => setOpenId(isOpen ? null : p.id)}
                >
                  <span className="pillar-num">{p.num}</span>
                  <Icon name={p.icon} className="pillar-icon" size={30} />
                  <span className="pillar-title">
                    <h3>{p.title}</h3>
                    <p>{p.tagline}</p>
                  </span>
                  <Icon name="chevron" className="pillar-chevron" size={22} />
                </button>

                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      className="collapsible"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <div className="pillar-body-inner">
                        <div>
                          <h4>What we deliver</h4>
                          <ul>
                            {p.deliver.map((d) => <li key={d}>{d}</li>)}
                          </ul>
                          <div className="outcome-box">
                            <b>Outcome:</b> {p.outcome}
                          </div>
                        </div>
                        <div>
                          <h4>Tools &amp; practice</h4>
                          <div className="chip-row">
                            {p.chips.map((c) => <span key={c} className="chip">{c}</span>)}
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
